import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["headingLevel", "role", "children"];
import styled from 'foundations-theming/utils';
import { DATA_TRANSITIONAL_COMPONENT_ATTRIBUTE } from '../../constants';
import { Header } from './Header';
import { useMapTokenPropsToCSS } from '../../../hooks/useMapTokenPropsToCSS';
import { filterProps } from '../../../utils/filterProps';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledSubheaderWrapper = styled.div.withConfig({
  displayName: "Subheader__StyledSubheaderWrapper"
})(({
  $cssStyles,
  theme
}) => {
  return {
    // Reset the padding and margin in the child Header component
    '& > header': Object.assign({
      marginBlockEnd: $cssStyles.marginBlockEnd || theme.space['600'],
      paddingBlockStart: $cssStyles.paddingBlockStart || theme.space['0']
    }, $cssStyles)
  };
});
export const Subheader = _ref => {
  let {
      headingLevel = 'h2',
      role = 'presentation',
      children
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    tokenProps
  } = filterProps(rest);
  const cssStyles = useMapTokenPropsToCSS(tokenProps);
  return /*#__PURE__*/_jsx(StyledSubheaderWrapper, {
    $cssStyles: cssStyles,
    [DATA_TRANSITIONAL_COMPONENT_ATTRIBUTE]: 'Subheader',
    children: /*#__PURE__*/_jsx(Header, Object.assign({}, rest, {
      headingLevel: headingLevel,
      fullWidth: true,
      flush: true,
      use: "condensed",
      role: role,
      children: children
    }))
  });
};